<template>
  <div>
	<loading 
	  :active.sync="isLoading" 
	  color="#85344c"
	></loading>
	<div class="content-wrapper">
	  <div class="container-fluid">
		<!-- Breadcrumbs-->
		<ol class="breadcrumb">
		  <li class="breadcrumb-item active">Titulares</li>
		</ol>

		<div class="row">
		  <div class="col-md-12" v-if="mostraErro">
			<div class="alert alert-danger alert-dismissible" role="alert">
			  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			  </button>
			  <strong>Ops!</strong>
			  <span>{{erroMensagem}}</span>
			</div>
		  </div>
		</div>

		<div class="row">
		  <div class="col-md-12">
			<router-link to="titulares/criar-titular"  class="btn_1 medium pull-right mb-3">Criar Titular</router-link>
		  </div>
		</div>

		<v-card>
		  <v-card-title>Titulares
			<v-spacer></v-spacer>
			<v-text-field
			  v-model="search"
			  append-icon="search"
			  label="Filtrar"
			  single-line
			  hide-details
			></v-text-field>
		  </v-card-title>
		  <v-data-table :headers="headers" :items="titulares" :search="search" :pagination.sync="pagination">
			<template slot="items" slot-scope="props" v-if="!(props.item.deleted_at)">
			  <td>{{ props.item.id }}</td>
			  <td>{{ props.item.name }}</td>
			  <td>{{ props.item.cpf | cpf }}</td>
			  <td>{{ props.item.email }}</td>
			  <td>{{ props.item.rg }}</td>
			  <td class="text-xs-right">
				<router-link
				  :to="'/adm/titulares/'+props.item.id"
				  class="btn_1 gray delete wishlist_close mt-1 mb-1"
				>
				  <i class="fa fa-fw fa-edit"></i> Detalhes
				</router-link>
				<button class="btn_1 red delete wishlist_close mt-1 mb-1" @click="desativaTitular(props.item)">
					<i class="fa fa-times"></i> Desativar
				</button>
			  </td>
			</template>
			<v-alert
			  slot="no-results"
			  :value="true"
			  color="error"
			  icon="warning"
			>Sua consulta para "{{ search }}" não teve resultado.</v-alert>
		  </v-data-table>
		</v-card>
	  </div>
	  <!-- /container-fluid-->
	</div>
  </div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from "axios";
import moment from "moment";
export default {
  mixins: [funcoesGerais],
  data() {
	return {
	  search: "",
	  erroMensagem: "",
	  mostraErro: false,
	  headers: [
		{ text: "ID", value: "id" },
		{ text: "Nome do titular", value: "name" },
		{ text: "CPF", value: "cpf" },
		{ text: "E-Mail", value: "email" },
		{ text: "RG", value: "rg" },
		{ text: "", value: "" } 
	  ],
	  titulares: [],
	  isLoading: false
	};
  },
  filters: {
	  cpf: function(value) {
		  return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3-\$4")
	  }
  },
  created() {
		var self = this;
		var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
		if (user) {
		self.isLoading = true;
		ajax("get", "/titulares")
			.then(response => {
			self.isLoading = false;
			self.titulares = response.data;
			})
			.catch(error => {
			self.isLoading = false;
			tratamento_requisicao(error, this);
			});
		} else {
			self.$router.replace(self.$route.query.redirect || "/");
		}
	},
	methods: {
		desativaTitular(titular) {
			let self = this;
			self.$swal.fire({
				title: 'Atenção!',
				text: "Deseja realmente desativar esse titular?",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Confirmar',
				cancelButtonText: 'Cancelar'
			}).then((result) => {
				if (result.value) {
					self.isLoading = true;
					ajax("delete", `titulares/${titular.id}`)
					.then(res => {
						let indexItemRemovido = self.titulares.findIndex(x => x.id == titular.id);
						self.titulares[indexItemRemovido].deleted_at = 1;
						self.isLoading = false;
						alerta("success", "Desativado", "Titular desativado com sucesso!");
					})
				}
			})
		}
	}
}
</script>